<div class="action-screen-container">
    <h2 *ngIf="currentRoute==='approval-trip'">Approve</h2>
    <h2 *ngIf="currentRoute==='reject-trip'">Reject</h2>

    <div class="comment-section">
      <label for="comment" class="comment-label">Add your Comment:</label>
      <textarea id="comment" placeholder="Write your comment here..." [(ngModel)]="comment"></textarea>
    </div>
  
    <div class="button-group">
      <button *ngIf="currentRoute==='approval-trip'" class="approve-button" (click)="onApprove()">Approve</button>
      <button *ngIf="currentRoute==='reject-trip'" class="reject-button" (click)="onReject()">Reject</button>
    </div>
  </div>




<div *ngIf="successPopup" class="overlay">  
    <!-- <div class="overlay">  -->
   <div class="success">
     <div class="col-md-12 row" style="padding-top: 20px;">
       <div class=" col-md-4"></div>
       <div  class="col-md-1"style=" display: flex; justify-content: center;padding-top: 25px;"><img src="../../../assets/images/star.png" width="10px"></div>
       <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 15px;"><img src="../../../assets/images/star.png" width="20px"></div>
       <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 25px;"><img src="../../../assets/images/star.png" width="15px"></div>
       <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 30px;"><img src="../../../assets/images/star.png" width="10px"></div>
     </div>
  <div class="col-md-12 row">
   <div class="col-md-3"></div>
   <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 75px;"><img src="../../../assets/images/star.png" width="15px"></div>
   <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 65px;"><img src="../../../assets/images/star.png" width="20px"></div>
   <div class="col-md-2" style=" display: flex; justify-content: center;padding-top: 10px;">
   <img *ngIf="action==='A'"  src="../../../assets/images/check.jpeg" width="80px">
   <img *ngIf="action==='D'"  src="../../../assets/images/crosss.png" width="80px">

  </div>
  <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 75px;"><img src="../../../assets/images/star.png" width="15px"></div>
  </div>
  
  <div class="col-md-12 row">
   <div class="col-md-1"></div>
   <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 95px;"><img src="../../../assets/images/star.png" width="10px"></div>
   <!-- <div class="col-md-12 drName " style="text-align: center;">
    <span class="drName " style="text-align: center;color: grey;">{{'Trip Approved Successfully'}} </span>
    </div> -->
   <div *ngIf="action==='A'"  class="col-md-9 usrAddScc" style=" display: flex; justify-content: center; padding-top: 25px;color: grey;"> Trip Approved Successfully</div>
   <div *ngIf="action==='D'"  class="col-md-9 usrAddScc" style=" display: flex; justify-content: center; padding-top: 25px;color: grey;"> Trip Rejected</div>

   <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 85px;"><img src="../../../assets/images/star.png" width="15px"></div>
  </div>
  
  <!-- <div class="col-md-12 drName " style="text-align: center;">
  <span>Agent Name:</span><span>{{'userName'}} </span>
  </div>
  <div class="col-md-12 "  style="text-align: center;">
  <span>Email: </span><span>{{'emailId'}} </span>
   </div> -->
   <div class="col-md-12 row">
     <div class="col-md-4"></div>
     <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 20px;"><img src="../../../assets/images/star.png" width="10px"></div>
     <div class="col-md-1"></div>
     <div class="col-md-1" style=" display: flex; justify-content: center;padding-top: 15px;"><img src="../../../assets/images/star.png" width="15px"></div>
     <div class="col-md-3"></div>
   </div>
  </div>
  </div>